import React, {useState} from "react";
import '../assets/css/Dentobook.css';
import DetailWrapper from "../components/common/DetailWrapper";
import {Modal} from "antd";
import {FormattedMessage} from "react-intl";
import {Navigate} from "react-router-dom";
import {OrganizationCreate as OrganizationCreateDTO} from "../api-client";
import OrganizationForm from "../components/organizations/OrganizationForm";
import {accessibilityRoles} from "../utils/accessUtils";
import AccessControl from "../components/common/AccessControl";

const OrganizationCreate = () => {

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    const [goBack, setGoBack] = useState<boolean>(false);

    const clinic: OrganizationCreateDTO = {
        name: ''
    };

    const handleOk = () => {
        setIsModalOpen(false);

        setGoBack(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    if (goBack) {
        return <Navigate to="/organizations"/>
    }

    return (
        <AccessControl accessibleFor={[accessibilityRoles.PLATFORM_ADMINISTRATOR]}>
            <Modal
                transitionName=""
                className="dentobook-modal"
                okButtonProps={{
                    className: "modal-btn"
                }}
                cancelButtonProps={{
                    className: "modal-btn"
                }}
                okText={<FormattedMessage id="confirm"/>}
                cancelText={<FormattedMessage id="cancel"/>}
                open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <br/>
                <h3 className="dentobook-content font-weight-500 font-24 text-align-center"><FormattedMessage id="unsaved_changes"/></h3>
            </Modal>
            <DetailWrapper navigateBack="/organizations">
                <h2><FormattedMessage id="create_organization"/></h2>
                <OrganizationForm openModal={() => setIsModalOpen(true)} clinic={clinic} setEditMode={undefined}/>
            </DetailWrapper>
        </AccessControl>
    );
};

export default OrganizationCreate;
